import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { GapSmall } from 'components/GapSmall';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { useEsc } from 'hooks/useEsc';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK, doReportingSelectReport } from 'store/actions';

export const ReportsSelect: React.FC<
  ModalScreenProps<ModalScreens.ReportsSelect>
> = ({ route }) => {
  const dispatch = useDispatch();
  const { pages } = route.params;

  const handleClose = React.useCallback(
    () => dispatch(NAVIGATE_MODAL_BACK()),
    [dispatch],
  );

  const handleSelect = React.useCallback(
    (id: string) => {
      dispatch(
        doReportingSelectReport({
          id,
          filter: { organisationIds: [] },
          key: null,
          loadData: false,
        }),
      );
    },
    [dispatch],
  );

  useEsc(handleClose);
  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Open Page"
          onPressCancelButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      <GapSmall>
        {pages.map((report) => (
          <Card key={report.id}>
            <CardRow
              label={report.name}
              label2={
                report.typeIsDefault ? undefined : `Based on ${report.typeName}`
              }
              value={report.description}
              labelAlignTop
              onPress={() => handleSelect(report.id)}
              icon={report.icon}
            />
          </Card>
        ))}
      </GapSmall>
    </Page>
  );
};
